var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserIcon = function SvgUserIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9594_22386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 16.6666C4.16797 14.62 5.82713 12.9608 7.8738 12.9608H12.1288C14.1755 12.9608 15.8346 14.62 15.8346 16.6666",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5069 4.37064C13.8901 5.75375 13.8901 7.99621 12.5069 9.37932C11.1238 10.7624 8.88138 10.7624 7.49827 9.37932C6.11516 7.99621 6.11516 5.75375 7.49827 4.37064C8.88138 2.98754 11.1238 2.98754 12.5069 4.37064Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9594_22386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgUserIcon as ReactComponent };
export default __webpack_public_path__ + "user-icon.svg";